import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import IconButton from 'components/common/IconButton';
import Menu, { MenuItem } from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import IconMoreVert from 'components/icons/IconMoreVert';
import EraActionCreateEditDialog from 'components/settings/EraActionCreateEditDialog';
import Link from 'components/common/Link';
import Chip from 'components/common/Chip';

import splitLongWords from 'utils/splitLongWords';

import hexToRgb from 'styles/hexToRgb';

import { deleteEraAction } from 'redux/modules/eraActions';

const styles = theme => ({
  buttonCell: {
    textAlign: 'right',
    padding: '0 10px 0 0',
    '&:last-child': {
      padding: '0 10px 0 0',
    },
  },
  iconPen: {
    width: 16,
    height: 16,
  },
  cellType: {
    textTransform: 'capitalize',
  },
  link: {
    wordBreak: 'normal',
  },
  chipCO: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.primary[500])}, 0.4)`,
  },
  chipOA: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.notification[500])}, 0.4)`,
  },
  chipPR: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.states.paid)}, 0.5)`,
  },
  chipCR: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.states.collection)}, 0.4)`,
  },
  chipPI: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.states.intake)}, 0.4)`,
  },
});

class EraActionsTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      editDialogOpen: false,
      deleteMenuOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onEditMenuItemClick = this.onEditMenuItemClick.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
    this.onDeleteMenuItemClick = this.onDeleteMenuItemClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
      deleteMenuOpen: false,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onEditMenuItemClick() {
    this.setState({
      anchorEl: null,
      editDialogOpen: true,
    });
  }

  onDeleteMenuItemClick() {
    this.setState({ deleteMenuOpen: true });
  }

  onDeleteCancel() {
    this.setState({ anchorEl: null });
  }

  onDeleteSubmit() {
    const { ID, actions } = this.props;
    actions.deleteEraAction({ ID });
    this.setState({
      deleteMenuOpen: false,
      anchorEl: null,
    });
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  render() {
    const { Group, Code, Action, classes, account, actions } = this.props;
    const { anchorEl, deleteMenuOpen, editDialogOpen } = this.state;
    const open = Boolean(anchorEl);

    return (
      <TableRow>
        <TableCell>
          <Chip
            className={classNames({
              [classes.chipCO]: Group.Code === 'CO',
              [classes.chipOA]: Group.Code === 'OA',
              [classes.chipPR]: Group.Code === 'PR',
              [classes.chipCR]: Group.Code === 'CR',
              [classes.chipPI]: Group.Code === 'PI',
            })}
            label={Group.Code}
            size="sm"
            square
          />
        </TableCell>
        <TableCell className={classes.cellType}>
          {Code.Code}
        </TableCell>
        <TableCell>
          {splitLongWords(Action)}
        </TableCell>
        <TableCell className={classes.buttonCell}>
          <IconButton
            aria-label="More"
            aria-owns={open ? `${this.props.ID}-era-action-menu` : null}
            aria-haspopup="true"
            onClick={this.onMenuButtonClick}
            tooltipContent="Open Menu"
          >
            <IconMoreVert className={classes.iconMoreVert} />
          </IconButton>
          <Menu
            id={`${this.props.ID}-era-action-menu`}
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list={!deleteMenuOpen}
            maxHeight={130}
          >
            {deleteMenuOpen ? (
              <DeleteMenu
                text="Are you sure you want to delete this action?"
                onCancel={this.onDeleteCancel}
                onSubmit={this.onDeleteSubmit}
              />
            ) : (
              <Fragment>
                <MenuItem onClick={this.onEditMenuItemClick}>
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={this.onDeleteMenuItemClick}
                  color="warning"
                  disabled={account.Roles.filter(item =>
                    item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
                >
                  Delete
                </MenuItem>
              </Fragment>
            )}
          </Menu>
        </TableCell>
        <EraActionCreateEditDialog
          form={`eraActionEdit-${this.props.ID}`}
          open={editDialogOpen}
          ID={this.props.ID}
          initialValues={{
            'Group Name': Group.Code,
            'Group ID': Group.ID,
            'Code Name': Code.Code,
            'Code ID': Code.ID,
            Action,
          }}
          onClose={this.onEditDialogClose}
          onSubmitSuccess={this.onEditDialogClose}
        />
      </TableRow>
    );
  }
}

EraActionsTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  Code: PropTypes.string.isRequired,
  Action: PropTypes.string,
  classes: PropTypes.shape({
    buttonCell: PropTypes.string.isRequired,
    iconPen: PropTypes.string.isRequired,
  }).isRequired,
};

EraActionsTableRow.defaultProps = {
  Action: null,
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deleteEraAction }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(EraActionsTableRow));



// WEBPACK FOOTER //
// ./src/components/settings/EraActionsTable/EraActionsTableRow.js